import { Customer } from '../types/dashboardInformation';

export const getCustomer = async (customerId: string): Promise<Customer> => {
    //@ts-ignore
    const getCustomerUrl = helpable.replaceUrlParameters(routable.getRoute('getCustomer'), {
        //@ts-ignore
        _customerId_: customerId,
    });
    try {
        const getCustomerResponse = await fetch(getCustomerUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
        if (!getCustomerResponse.ok) {
            const error = await getCustomerResponse.json();
            //@ts-ignore
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('swal.button.text.ok'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return error.message;
        }
        const { data } = await getCustomerResponse.json();

        return data;
    } catch (error) {
        console.error(error.message);
    }
};
